module.exports = __webpack_public_path__ + "static/media/5.d078f713.jpg";